import { render } from "./LoginButton.vue?vue&type=template&id=793b72b3&scoped=true&ts=true"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"

import "./LoginButton.vue?vue&type=style&index=0&id=793b72b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793b72b3"]])

export default __exports__